<script>
import { TableColumn } from 'element-ui'
export default {
  props: TableColumn.props,
  render(){
    let { prop, label } = this.$props;
    return (
      <TableColumn
        {...{ props: { ...this.$props, ...{ prop: null, property: null } } } }
        scopedSlots={{
          header: () => {
            return  this.$slots.header || label
          },
          default: scope => {
            let noData = (<span class="cell-nodata">无</span>);
            if(this.$scopedSlots.default){
              try{
                let temp = this.$scopedSlots.default(scope);
                let index = temp.findIndex(item => {
                  if(item.tag || item.text.replace(/\r\n/g, '').replace(/\n/g, '').replace(/\s/g, ''))
                    return true
                  return false;
                })
                return index == -1
                ? noData
                : temp
              }catch(e){
              }
              return noData
            }
            return scope.row[prop] || noData
          }
        }}>
      </TableColumn>
    )
  }
}
</script>

<style lang="scss" scoped>
.cell-nodata{
  font-size: 12px;
  color: $text3;
}
</style>



// WEBPACK FOOTER //
// src/components/page/TableCell.vue